import { render, staticRenderFns } from "./PoiManagerPanel.vue?vue&type=template&id=372df47a&scoped=true"
import script from "./PoiManagerPanel.vue?vue&type=script&lang=js"
export * from "./PoiManagerPanel.vue?vue&type=script&lang=js"
import style0 from "./PoiManagerPanel.vue?vue&type=style&index=0&id=372df47a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372df47a",
  null
  
)

export default component.exports